export class rolFetch {
    nombre: String;
    grupo: String;
}